module.exports = __webpack_public_path__ + "static/media/Flow-Charts-EG-P15.78f8aefb.jpg";